import Markdown from "markdown-to-jsx";
import Slider from "react-slick";
import styles from "./proprietyDetails.module.css";

export default function ProprietyDetails({ data }) {
  const settings = {
    className:
      data.detalhesItems.length >= 5 ? "propertyDetail" : "propertyDetail2",
    slidesToShow: data.detalhesItems.length >= 5 ? 4 : 2,
    slidesToScroll: data.detalhesItems.length >= 5 ? 4 : 2,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="grid-cont">
      <div className={styles.container}>
        <img src={data?.iconeImovel?.url} width={145} height={145} />

        <div className={styles.unitys}>
          <div>
            <img src="/icons/mark.svg" width={18} height={24}/>
            <span>{data?.unidade.nome}</span>
          </div>
          <Markdown>{data?.unidade?.texto}</Markdown>
        </div>
        <div className={styles.details}>
          <Slider {...settings}>
            {data.detalhesItems &&
              data?.detalhesItems.map((item) => {
                return (
                  <div key={item.id} className={styles.detailItem}>
                    <div>
                      <img src={item.icone.url} width={54} height={54} />
                    </div>
                    <span>{item.detalhe}</span>
                  </div>
                );
              })}
          </Slider>
        </div>
      </div>
    </div>
  );
}
